module.exports = __webpack_public_path__ + "img/m4_t1_en.60d15202.svg";